import axios from 'axios';
import { message } from 'ant-design-vue';
import store from '@/store';
import { getToken, genAuthorization } from './auth';
import Vue from 'vue';
import router from '@/router';

const HOME_PAGE = '/';
// create an axios instance
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API, // url = base url + request url
  withCredentials: true, // send cookies when cross-domain requests
  timeout: 20000, // request timeout
});

// request interceptor
service.interceptors.request.use(
  (config) => {
    // do something before request is sent
    config.headers['sign'] = genAuthorization(config.data || {});
    if (config.method === 'post') {
      if (
        config.headers['content-type'] !== 'application/json' &&
        config.headers['content-type'] !== 'multipart/form-data'
      ) {
        const querystring = require('querystring');
        config.data = querystring.stringify(config.data);
      }
    }
    if (store.getters.token) {
      // please modify it according to the actual situation
      config.headers['Authorization'] = getToken();
    }
    //在请求投中统一携带header获取用户的分辨率
    const height = window.screen.height;
    const width = window.screen.width;
    config['headers']['Display-Size'] = width + '*' + height;
    //天池pc：0，飞书小程序：1
    config['headers']['Client-Type'] = 0;
    return config;
  },
  (error) => {
    // do something with request error
    console.log(error); // for debug
    return Promise.reject(error);
  }
);

// response interceptor
service.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
   */

  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  (response) => {
    let {
      config: { errorToast = true },
    } = response;
    response = response.data;

    response.code = Number(response.code);
    if (response instanceof Blob) {
      response.code = 200;
    }
    switch (response.code) {
      case 200:
        return Promise.resolve(response);
      case 401:
        // token过期，请重新登录
        store.dispatch('SET_LOGOUT');
        router.push('/login');
        return Promise.resolve(response);
      default:
        //出现异常
        if (errorToast) {
          Vue.prototype.$message.error(
            response.msg ||
              (response.code === 403 && '无权限') ||
              (response.code === 500 && '服务端错误') ||
              '操作失败'
          );
        }
        return Promise.resolve(response);
    }
  },
  (error) => {
    console.log(error);
    const response = error.response.data;
    console.log(response);
    response.code = Number(response.code);
    message.destroy();
    switch (response.code) {
      default:
        response.msg !== '' && Vue.prototype.$message.error(response.msg);
        return Promise.reject(error);
    }
  }
);

export default service;
